import { MenuItem, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserPreference } from "../../utilities/common";

function UpdatePattern(props) {
    const { t } = useTranslation('bbcOrderManagement');
    const userPref = getUserPreference();

    const TYPE_LIST = [{
        code: 'tnos',
        name: t('tnos')
    }, {
        code: 'bag_nos',
        name: t('bag_nos')
    }, {
        code: 'sub_batch',
        name: t('sub_batch')
    }]

    const STATUS_LIST = [{
        code: 'ready_pickup',
        name: t('ready_for_pickup')
    }, {
        code: 'gateway_out',
        name: t('gateway_out')
    }, {
        code: 'picked_up',
        name: t('picked_up')
    }]

    const [inputType, setInputType] = useState('tnos');
    const [input, setInput] = useState();
    const [targetStatus, setTargetStatus] = useState('ready_pickup');
    const [count, setCount] = useState(0);

    useEffect(() => {
        let dataJoint = '';
        if (input) {
            dataJoint = input.replaceAll(/\n\s*\n/g, '\n');
            dataJoint = dataJoint.replaceAll('\n', ',');
            dataJoint = dataJoint.trim();
            if (dataJoint.charAt(0) === ',') {
                dataJoint = dataJoint.substring(1);
            }
            if (dataJoint.charAt(dataJoint.length - 1) === ',') {
                dataJoint = dataJoint.substring(0, dataJoint.length - 1);
            }
        }
        props.handleParams({
            update_type: inputType,
            data: dataJoint,
            to_state: targetStatus,
            scan_location: userPref.userCity
        })
    }, [inputType, input, targetStatus])

    return (
        <div>
            <div style={{ marginTop: 18 }}>{t('hinge')}</div>
            <div style={{ marginTop: 18 }}>
                <TextField
                    variant="outlined"
                    select
                    value={inputType}
                    fullWidth
                    onChange={(e) => setInputType(e.target.value)}
                >
                    {
                        TYPE_LIST.map((type) => (
                            <MenuItem
                                key={type.code}
                                value={type.code}
                            >
                                {type.name}
                            </MenuItem>
                        ))
                    }
                </TextField>
                <TextField
                    label={t(`${inputType}`)}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    variant='outlined'
                    placeholder={t('input_memo')}
                    multiline
                    rows={4}
                    fullWidth
                    style={{ marginTop: 12 }}
                />
                <TextField
                    variant="outlined"
                    select
                    value={targetStatus}
                    fullWidth
                    style={{ marginTop: 12 }}
                    onChange={(e) => setTargetStatus(e.target.value)}
                    label={t('target_status')}
                >
                    {
                        STATUS_LIST.map((status) => (
                            <MenuItem
                                key={status.code}
                                value={status.code}
                            >
                                {status.name}
                            </MenuItem>
                        ))
                    }
                </TextField>
            </div>
        </div>
    );
}
export default UpdatePattern;